import { takeLatest } from 'redux-saga/effects';
import types from './action-types';
import {
  getContractsFiltersSaga,
  getListOfContractsSaga,
  saveContractSaga,
  getContractDetailsSaga,
  changeOfVehicleSaga,
  createLoanSaga,
  updateContractSaga,
  getManagersSaga,
  getCoordinatorsSaga,
  getAdminFleetsSaga,
  getContractVehiclesSaga,
  downloadTemplateVCSaga,
  uploadVehiclesSaga,
  downloadFailedRecordsSaga,
} from './sagas';

export default function* watchers() {
  yield takeLatest(types.GET_LIST, getListOfContractsSaga);
  yield takeLatest(types.GET_FILTERS, getContractsFiltersSaga);
  yield takeLatest(types.SAVE_CONTRACT, saveContractSaga);
  yield takeLatest(types.GET_CONTRACT_DETAILS, getContractDetailsSaga);
  yield takeLatest(types.CHANGE_OF_VEHICLE, changeOfVehicleSaga);
  yield takeLatest(types.CREATE_LOAN, createLoanSaga);
  yield takeLatest(types.UPDATE_CONTRACT, updateContractSaga);
  yield takeLatest(types.GET_MANAGERS, getManagersSaga);
  yield takeLatest(types.GET_COORDINATORS, getCoordinatorsSaga);
  yield takeLatest(types.GET_ADMIN_FLEETS, getAdminFleetsSaga);
  yield takeLatest(types.GET_CONTRACT_VEHICLES, getContractVehiclesSaga);
  yield takeLatest(types.DOWNLOAD_TEMPLATE_VC_MASSIVE_LOAD, downloadTemplateVCSaga);
  yield takeLatest(types.UPLOAD_VEHICLES_VC, uploadVehiclesSaga);
  yield takeLatest(types.DOWNLOAD_FAILED_RECORDS_VC, downloadFailedRecordsSaga);
}
